import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from "react"; //Limitless imports

import { log as pilog, ClientContext } from "../../utils";
import { fetchPlatformResources } from "../../apis/resource-api/ResourceAPI";
import { UI_LABELS_JSON } from "../../apis/resource-api/RemoteResourceUtil";
export var LIMITLESS_LOCALE_KEY = "limitless-locale";
var INITIAL_STATE = {
  loading: true,
  failedToLoad: false
};

var getInitialState = function getInitialState(resourceList, defaultContentMap) {
  var initialState = _objectSpread({}, INITIAL_STATE);

  resourceList.map(function (resourceItem) {
    var stateKey = resourceItem.stateKey,
        defaultContent = resourceItem.defaultContent;
    var content = defaultContentMap[stateKey] ? defaultContentMap[stateKey] : defaultContent;
    initialState = _objectSpread({}, initialState, _defineProperty({}, stateKey, content));
  });
  return initialState;
};
/**
 * Loads S3 resource from the platform for a given application
 *
 * @param {array} resourceList
 * @param {string} applicationName
 */


export var usePlatformResource = function usePlatformResource(resourceList, applicationName, defaultContentMap) {
  var delayResourcesAPICall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var previousLocale = arguments.length > 4 ? arguments[4] : undefined;
  var log = pilog.getLogger("useConfig");

  var _React$useState = React.useState(getInitialState(resourceList, defaultContentMap)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      resources = _React$useState2[0],
      setResources = _React$useState2[1];

  log.debug(resources);
  React.useEffect(function () {
    if (!delayResourcesAPICall) {
      loadAppResources();
    }
  }, []);

  var setApplicationLanguage = function setApplicationLanguage(newLocale) {
    if (newLocale !== ClientContext._locale) {
      ClientContext._locale = newLocale; //remember the locale for next time

      localStorage.setItem(LIMITLESS_LOCALE_KEY, newLocale);
      loadAppResources(newLocale);
    }
  };

  var loadAppResources = function loadAppResources() {
    var targetLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : previousLocale;
    //if previousLocale is null, fetchPlatformResources will use the ClientContext one
    fetchPlatformResources({
      locale: targetLocale,
      resourceList: resourceList,
      applicationName: applicationName
    }, function (result) {
      var newState = {};
      resourceList.map(function (resourceItem) {
        var defaultContent = resourceItem.defaultContent,
            name = resourceItem.name,
            formatRemoteContent = resourceItem.formatRemoteContent,
            stateKey = resourceItem.stateKey;
        var platformData = result.find(function (r) {
          return r.resourceName === name;
        });

        if (platformData.content) {
          newState[stateKey] = formatRemoteContent ? formatRemoteContent(platformData.content, defaultContentMap[stateKey]) : platformData.content;
        } else {
          newState[stateKey] = defaultContentMap[stateKey] || defaultContent;
        }

        if (platformData) {
          newState = _objectSpread({}, newState);
        }
      });
      setResources(_objectSpread({}, resources, {}, newState, {
        loading: false
      }));
    }, function () {
      //error callback
      log.error("Unable to load platform resources, defaults will be used");
      setResources(_objectSpread({}, resources, {
        loading: false,
        failedToLoad: true
      }));
    });
  };

  var updateResourceValue = function updateResourceValue(key, value) {
    setResources(_objectSpread({}, resources, _defineProperty({}, key, value)));
  };

  var mergeUILabels = function mergeUILabels(newLabels) {
    setResources(_objectSpread({}, resources, _defineProperty({}, UI_LABELS_JSON.stateKey, _objectSpread({}, resources.uiLabels, {}, newLabels))));
  };

  var updateUILabels = function updateUILabels(newLabels) {
    setResources(_objectSpread({}, resources, _defineProperty({}, UI_LABELS_JSON.stateKey, newLabels)));
  };

  return {
    resources: resources,
    loadAppResources: loadAppResources,
    updateResourceValue: updateResourceValue,
    setApplicationLanguage: setApplicationLanguage,
    mergeUILabels: mergeUILabels,
    updateUILabels: updateUILabels
  };
};